import LookupText from '../../Elements/LookupText';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import React from 'react';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import urlHelper from '../../Helpers/urlHelper';
import AuthService from '../../Services/authService';
import DataTableActionMenu from '../../Elements/DataTable/DataTableActionMenu';
import moneyHelper from '../../Helpers/moneyHelper';

export default class CreditMemoRequestItem {
  constructor(item) {
    this.initialize(item);
    this.Selected = false;
  }

  async initialize(item) {
    if (item === undefined) {
      this.ClientInvoiceClientName = '';
      this.ClientInvoiceOfficeName = '';
      this.CreditMemoRequestId = '';
      this.InternalReferenceNumber = '';
      this.Reason = '';
      this.Description = '';
      this.AssignedToName = '';
      this.AssignedTo = '';
      this.FeeCredit = '';
      this.CurrencySymbol = '';
      this.LineItemCount = '';
      this.Status = '';
      this.ClientInvoiceClientId = '';
      this.ClientInvoiceClientNameWithId = '';
      this.ClientInvoiceStatusCode = '';
      this.InternalInformation = '';
      this.CreatedByName = '';
      this.ApprovedByName = '';
      this.ClientInvoiceId = '';
      this.CreatedOn = '';
      this.CreatedOnFormatted = '';
      this.AssignedOn = '';
      this.AssignedOnFormatted = '';
      this.ApprovedOn = '';
      this.ApprovedOnFormatted = '';
      this.SupervisorName = '';
      this.CreditMemoApproverName = '';
      this.CreditMemoFinalizedOn = '';
      this.CreditMemoFinalizedOnFormatted = '';
      this.CreditMemoNumber = '';
      this.SubmittedBy = '';
      this.CurrencyCode = '';
      this.LineItemCreditAmount = '';
      this.FromClientInvoice = false;
      return;
    }
    this.ClientInvoiceClientName = item.clientInvoiceClientName;
    this.ClientInvoiceOfficeName = item.clientInvoiceOfficeName;
    this.CreditMemoRequestId = item.creditMemoRequestId;
    this.InternalReferenceNumber =
      item.internalReferenceNumber === null || item.internalReferenceNumber === '' ? ' ' : item.internalReferenceNumber;
    this.Reason = item.reason;
    this.Description = item.description;
    this.AssignedToName = item.assignedToName;
    this.AssignedTo = item.assignedTo;
    this.FeeCredit = item.feeCredit;
    this.CurrencySymbol = item.currencySymbol;
    this.LineItemCount = item.lineItemCount;
    this.Status = item.status;
    this.ClientInvoiceClientId = item.clientInvoiceClientId;
    this.ClientInvoiceClientNameWithId = `${this.ClientInvoiceClientName} (${this.ClientInvoiceClientId})`;
    this.ClientInvoiceStatusCode = item.clientInvoiceStatusCode;
    this.InternalInformation = item.internalInformation;
    this.CreatedByName = item.createdByName;
    this.ApprovedByName = item.approvedByName === null ? ' ' : item.approvedByName;
    this.ClientInvoiceId = item.clientInvoiceId;
    this.CreatedOn = item.createdOn;
    this.CreatedOnFormatted = dateTimeHelper.toYYYYsMMsDDsHHsMM(this.CreatedOn, '-');
    this.AssignedOn = item.assignedOn;
    this.AssignedOnFormatted = dateTimeHelper.toYYYYsMMsDDsHHsMM(this.AssignedOn, '-');
    this.ApprovedOn = item.approvedOn;
    this.ApprovedOnFormatted = item.approvedOn === null ? ' ' : dateTimeHelper.toYYYYsMMsDDsHHsMM(this.ApprovedOn, '-');
    this.SupervisorName = item.supervisorName === null ? ' ' : item.supervisorName;
    this.CreditMemoApproverName = item.creditMemoApproverName === null ? ' ' : item.creditMemoApproverName;
    this.CreditMemoFinalizedOn = item.creditMemoFinalizedOn;
    this.CreditMemoFinalizedOnFormatted =
      item.creditMemoFinalizedOn === null ? ' ' : dateTimeHelper.toYYYYsMMsDDsHHsMM(item.creditMemoFinalizedOn, '-');
    this.CreditMemoNumber = item.creditMemoNumber === null ? ' ' : item.creditMemoNumber;
    this.CurrencyCode = item.currencyCode;
    this.SubmittedBy = item.submittedBy;
    this.LineItemCreditAmount = item.lineItemCreditAmount;
    this.LineItemCredit = item.lineItemCredit;
    this.FromClientInvoice = false;
  }

  static NameOfTheIdField() {
    return 'CreditMemoRequestId';
  }
  static nameOfTheItemDetailList() {
    return 'Credit Memo Request';
  }
  static MoneyFields = ['FeeCredit', 'LineItemCreditAmount'];
  static Currency() {
    return 'CurrencyCode';
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }
  static DateFields = [];
  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { label: 'Credit Memo Request ID', name: 'CreditMemoRequestId', className: 'text-left' },
        { label: 'Internal Reference', name: 'InternalReferenceNumber', className: 'text-left' },
        { label: 'Status', name: 'Status', className: 'text-left' },
        { label: 'Reason', name: 'Reason', className: 'text-left' },
        { label: 'Finalized On', name: 'CreditMemoFinalizedOnFormatted', className: 'text-left' },
        { name: 'CreditMemoNumber', label: 'Credit Memo #', className: 'text-left' },
        { label: 'Invoice #', name: 'ClientInvoiceId', className: 'text-left' },
        {
          label: 'Client Invoice Status',
          name: (item) => (
            <LookupText
              lookupId={43}
              value={item.ClientInvoiceStatusCode}
            />
          ),
          className: 'text-left',
        },
        {
          label: 'Client',
          name: (item) => `${item.ClientInvoiceClientName} (${item.ClientInvoiceClientId})`,
          className: 'text-left',
        },
        { label: '# Items Credited', name: 'LineItemCount', className: 'text-left' },
        {
          label: 'Gross Credit Amount',
          name: (item) => moneyHelper.toMoneyFormat(item.LineItemCredit, item.CurrencyCode),
          className: 'text-left',
        },
        {
          label: 'Description',
          name: 'Description',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
        },
        {
          label: 'Internal Information',
          name: 'InternalInformation',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
        },
        { label: 'Created By', name: 'CreatedByName', className: 'text-left' },
        { label: 'Assigned To', name: 'AssignedToName', className: 'text-left' },
        { label: 'Approved By', name: 'ApprovedByName', className: 'text-left' },
        { label: 'Created On', name: 'CreatedOnFormatted', className: 'text-left' },
        { label: 'Assigned On', name: 'AssignedOnFormatted', className: 'text-left' },
        { label: 'Approved On', name: 'ApprovedOnFormatted', className: 'text-left' },
        { label: 'Supervisor', name: 'SupervisorName', className: 'text-left' },
        { label: 'Credit Memo Approver', name: 'CreditMemoApproverName', className: 'text-left' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Client Name', orderById: 'ClientInvoiceClientName', data: 'ClientInvoiceClientName' },
      { label: 'Office', orderById: 'ClientInvoiceOfficeName', data: 'ClientInvoiceOfficeName' },
      {
        label: 'Request ID',
        orderById: 'CreditMemoRequestId',
        data: CreditMemoRequestItem.GetDetailCellContent,
        minWidth: 70,
      },
      {
        label: 'Gross Credit',
        orderById: 'LineItemCreditAmount',
        data: (item) => moneyHelper.toMoneyFormat(item.LineItemCredit, item.CurrencyCode),
      },
      { label: '# Items Credited', orderById: 'LineItemCount', data: 'LineItemCount', minWidth: 110 },
      { label: 'Status', orderById: 'Status', data: 'Status' },
      { label: 'Assigned To', orderById: 'AssignedToName', data: 'AssignedToName' },
      { label: 'Reason', orderById: 'Reason', data: 'Reason' },
      {
        label: 'Description',
        orderById: 'Description',
        data: (item) => (item.Description.length > 76 ? `${item.Description.substring(0, 76)} ...` : item.Description),
      },
      {
        label: ' ',
        orderById: '',
        data: CreditMemoRequestItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            onClick: () => CreditMemoRequestItem.editFunction(item.CreditMemoRequestId, item),
            iconName: 'fa-solid fa-edit',
            roleKey: 'creditmemo_editfaicon',
          },
          {
            iconName: 'fa-solid fa-retweet',
            text: 'Status Change',
            roleKey: 'creditmemo_editfaicon',
            onClick: () => CreditMemoRequestItem.statusChangeFunction(item.CreditMemoRequestId, item),
            disabled:
              item.Status === 'Closed' ||
              item.Status === 'Approved' ||
              (item.SubmittedBy !== AuthService.getInstance().GetLoggedInUser().userId &&
                item.AssignedTo !== AuthService.getInstance().GetLoggedInUser().userId &&
                !AuthService.IsAdmin()),
          },
        ]}
      />
    );
  }

  static statusChangeFunction = () => {
    alert('Empty function');
  };

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.CreditMemoRequestId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'creditmemorequestdetails',
      `id=${item.CreditMemoRequestId}`,
      'Open up in a new tab'
    );
  }
}
